import React from "react";
import moment from "moment";
import { component_tool } from "../../../tool"
import HighSet from "@/containers/common/highSet";

let { WizDivider, WizModal } = component_tool

let componentName = 'apply'
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}

const columns = [
  {
    name: 'id',
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "报名名称",
    name: "name",
    searchItem: {},
    tableItem: {
      width: 300
    }
  },
  {
    title: "报名状态",
    name: "statusList",
    dataIndex: "status",
    searchItem: {
      type: 'select',
      mode: 'multiple',
      formatInit: () => [0,1,2]
    },
    dict: [
      { code: 0, codeName: "草稿" },
      { code: 1, codeName: "报名中" },
      { code: 2, codeName: "已取消" },
      { code: 3, codeName: "已关闭" },
    ],
  },
 /*  {
    title: "报名状态",
    name: "status",
    searchItem: {
      type: "select"
    },
    dict: [
      { code: 0, codeName: "草稿" },
      { code: 1, codeName: "报名中" },
      { code: 2, codeName: "已取消" },
      { code: 3, codeName: "已关闭" },
    ]
  }, */
  {
    title: '报名时间',
    name: 'applyDate',
    dataIndex: "applyDate",
    tableItem: {
      render: (text, record) => {
        const { startTime, endTime } = record;
        let classDate = formatterDate(startTime) + " ~ " + formatterDate(endTime);
        return classDate
      }
    },
    searchItem: {
      type: 'date~',
      showTime: true,
    },
  },
  {
    title: "安排类型",
    name: "planType",
    tableItem: {},
    searchItem: {
      type: 'select'
    },
    dict: [
      { code: 0, codeName: "公共" },
      { code: 1, codeName: "班级" },
      // {code: 2, codeName: "活动"},
    ]
  },
  {
    title: "报名人数",
    name: "applyNumber",
    tableItem: {}
  },
  {
    title: "通过人数",
    name: "passNumber",
    tableItem: {}
  },
  {
    title: "待审核人数",
    name: "reviewNumber",
    tableItem: {}
  },
  {
    title: "总人数",
    name: "totalNumber",
    tableItem: {
      render: (text, record) => {
        if (text < 0) {
          text = '不限制'
        }
        return text
      }
    }
  },
  {
    title: "报名状态",
    name: "status",
    tableItem: {},
    dict: [
      { code: 0, codeName: "草稿" },
      { code: 1, codeName: "报名中" },
      { code: 2, codeName: "已取消" },
      { code: 3, codeName: "已关闭" },
    ]
  },
  {
    title: '审核起止时间',
    name: 'applyAuditDate',
    dataIndex: "applyAuditDate",
    tableItem: {
      render: (text, record) => {
        const { auditStartTime, auditEndTime } = record;
        let classDate = ''
        if (auditStartTime) {
          classDate = formatterDate(auditStartTime) + " ~ " + formatterDate(auditEndTime);
        }
        return classDate
      }
    },
  },
];

// function _planManagement(e) {
//   log.info("eeeee:",e)
// }

const templateConfig = (e) => {
  let {_planManagement, pathname} = e
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns,
        searchBarProps: {
          cols: {
            xs: 24,
            md: 12,
            xl: 8
          },
          dataFormat: (v) => {
            let value = Object.assign([], v)
            if (value['applyDate'] && value['applyDate'].length === 2) {
              value['startTime'] = moment(value['applyDate'][0]).format("YYYY-MM-DD HH:mm:00")
              value['endTime'] = moment(value['applyDate'][1]).format("YYYY-MM-DD HH:mm:59")
            }else{
              value['startTime'] = undefined;
              value['endTime'] = undefined;
            }
            // delete value['applyDate']
            return value
          },
          buttonSort: ['add','delete', 'exportRegistrationRecord', 'exportReceiptSurvey'],//'delete'
          buttons: [
            {
              key: 'add',
              custom: true,
              params: {icon: 'plus', children: '新增', type: 'primary'},
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  //新增跳转页面
                  pathname: pathname+'/applyDetailAdd'
                }
              }
            },
            {
              key: 'exportRegistrationRecord',
              custom: true,
              params: {icon: 'export', children: '导出报名记录', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  if (rows && rows.length && rows.length == 1) {
                    let id;
                    rows.forEach(d => {
                      id = d.id
                    })
                    filters = {id: id}
                    return {...filters}
                  } else {
                    WizModal.confirm({
                      title: '请选择一条数据',
                      onOk: () => {
                      },
                      onCancel() {
                      }
                    })
                  }
                }
              }
            },
            {
              key: 'exportReceiptSurvey',
              custom: true,
              params: {icon: 'export', children: '导出回执问卷', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "surveyAnswerList",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  if (rows && rows.length && rows.length == 1) {
                    let surveyId;
                    let id;
                    rows.forEach(d => {
                      surveyId = d.surveyId
                      id = d.id
                    })
                    if (surveyId && surveyId > 0) {
                      filters = {id: id}
                      return {...filters}
                    } else {
                      WizModal.confirm({
                        title: '该报名未选择对应问卷',
                        onOk: () => {
                        },
                        onCancel() {
                        }
                      })
                    }
                  } else {
                    WizModal.confirm({
                      title: '请选择一条数据',
                      onOk: () => {
                      },
                      onCancel() {
                      }
                    })
                  }
                }
              }
            }

          ],
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: 'checkbox',
          isScroll: true,
          loading: false
        },
        rowOperateSort: ['update', 'look', 'releaseOrClose', 'applyPlanManagement', 'registrationRecordManagement', 'applyVerifyManagement', 'advancedSet'],
        rowOperateView: [
          {
            key: "releaseOrClose",
            custom: true,
            params: {children: "发布"},
            textFormat: {
              recordKey: 'status',
              dirt: {0: '发布', 2: '发布', 1: '关闭'}
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "enable",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要${
                  record['status'] === 0 || record['status'] === 2 ? "发布" : "关闭"
                }该报名吗？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      status: record['status'] === 0 || record['status'] === 2 ? 1 : 2,
                      id: record['id']
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          },
          {
            key: "update",
            custom: true,
            params: {children: "编辑"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: pathname+"/applyDetailUpd"
              }
            }
          },
          {
            key: "look",
            custom: true,
            params: {children: "查看"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: pathname+"/applyInfo"
              }
            }
          },
          {
            key: 'applyPlanManagement',
            name: "WizButton",
            params: {
              children: '计划安排管理',
              key: "applyPlanManagement"
            },
            onClick: e => _planManagement && _planManagement(e)
          },
          {
            key: 'registrationRecordManagement',
            custom: true,
            params: {children: '报名记录管理'},
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                //新增跳转页面
                pathname: pathname+'/applyManager'
              },
            }
          },
          {
            key: "applyVerifyManagement",
            custom: true,
            params: {children: "报名审核管理"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: pathname+"Verify"
              }
            }
          },
          {
            key: 'advancedSet',
            custom: true,
            params: {children: '高级设置'},
            customOnClick: {
              key: 'modal',
              params: {
                modalParams: {
                  title: '高级设置',
                  bordered: true,
                  footer: null,
                  destroyOnClose: true,
                  diy: (e) => {
                    //BIZ_APPLY = 15;
                    return <>
                      <HighSet data={{record: e.record, bizType: 15}}
                               changeModal={e.changeModal}
                      />
                    </>
                  },
                  width: 950
                },
              }
            },
            recordChangeParams: ({record, rows}) => {
              let disabled = false
              if (record && (record['status'] === 2 || record['status'] === 3)) {
                disabled = true
              }
              return {disabled}
            }
          }
        ],
        commonOperate: {
          add: true,
          delete: true,
          update: true,
          look: true
        }
      }
    },
    dataTableProps: {
      rowKey: "id",
      selectType: "checkbox",
      isScroll: true,
      bordered: false,
      paging: false,
      loading: false,
    },
  }
};

const apis = (params = {}) =>  {
  return{
    list: {
      path: `${componentName}/listByPage`,
      payload: {
        key: `${componentName}@listByPage`,
        apiParams: { pageNum: 1, pageSize: 10, statusList: [0,1,2], ...(params || {}) }
      }
    },
    delete: {
      path: `${componentName}/delete`,
      payload: {
        key: `${componentName}@delete`,
        apiParams: {}
      }
    },
    enable: {
      path: `${componentName}/enable`,
      payload: {
        key: `${componentName}@enable`,
        apiParams: {}
      }
    },
    update: {
      path: `${componentName}/update`,
      payload: {
        key: `${componentName}@update`,
        apiParams: {}
      }
    },
    export: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@export`,
        apiParams: { statusList: [0,1,2], ...(params || {}) }
      }
    },
    surveyAnswerList: {
      path: `${componentName}/surveyAnswerList`,
      payload: {
        key: `${componentName}@surveyAnswerList`,
        apiParams: {}
      }
    }
  }
}


let reduxTemplateCofig = (args) => {
  return {
    apis: apis(args['params']),
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    keepInitApiParams: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
